import { useProductPageStore } from '../../contexts/ProductPageStore'
import { EngineFitmentFeedbackModalButton } from './engineFitmentFeedback'

import { useEffect, useRef, useState } from 'react'

import useFeatureFlag from 'Clutch/Hooks/useFeatureFlag'

import Modal from 'Clutch/Components/Modal/ModalWithPortal'

const EngineFitmentFeedbackWrapper = () => {
  const engineFitmentForSku = useProductPageStore((x) => x.engineFitmentForSku)
  const internalRequestEngineFitment = useProductPageStore((x) => x.internalRequestEngineFitment)
  const isUniversalEngineFitment = useProductPageStore((x) => x.isUniversalEngineFitment)
  const skuVariantNumber = useProductPageStore((x) => x.skuVariantNumber)

  const feedbackEnabled = useFeatureFlag('PDP_Show_Fitment_Feedback_Internals')
  const [showFeedback, setShowFeedback] = useState(false)
  const [requestFitmentSuccess, setRequestFitmentSuccess] = useState(false)
  const modal = useRef(null)

  useEffect(() => {
    if (showFeedback) modal?.current?.open()
    if (!showFeedback) modal?.current?.close()
  }, [showFeedback])

  try {
    let EngineFitmentFeedbackModalContents
    if ((!!engineFitmentForSku || internalRequestEngineFitment) && !!feedbackEnabled) {
      EngineFitmentFeedbackModalContents = require('./engineFitmentFeedback').default
    }

    return (
      <>
        <EngineFitmentFeedbackModalButton
          requestFitmentSuccess={requestFitmentSuccess}
          showFeedback={showFeedback}
          setShowFeedback={setShowFeedback}
          shouldRender={(!!engineFitmentForSku || internalRequestEngineFitment) && !!feedbackEnabled}
          internalRequestEngineFitment={internalRequestEngineFitment}
        />
        <Modal id={'engineFitmentFeedbackModal'} outsideClick ref={modal} customOnClose={() => setShowFeedback(false)}>
          {EngineFitmentFeedbackModalContents && (
            <EngineFitmentFeedbackModalContents
              skuNumber={skuVariantNumber}
              engineFitmentData={engineFitmentForSku}
              internalRequestEngineFitment={internalRequestEngineFitment}
              setRequestFitmentSuccess={setRequestFitmentSuccess}
              isUniversalEngineFitment={isUniversalEngineFitment}
            />
          )}
        </Modal>
      </>
    )
  } catch (err) {
    console.error(err)
    return false
  }
}

export default EngineFitmentFeedbackWrapper
